import React from "react";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import { connect } from "react-redux";

import Undo from "./Undo";
import Redo from "./Redo";

let UndoRedo = ({ canUndo, canRedo, onUndo, onRedo }) => (
  <div className="undo">
    <Undo onUndo={onUndo} canUndo={canUndo} />
    <Redo onRedo={onRedo} canRedo={canRedo} />
  </div>
);

const mapStateToProps = (state) => {
  const past = state.design.past || []; // Default to an empty array if undefined
  const future = state.design.future || []; // Default to an empty array if undefined

  return {
    canUndo: past.length > 0,
    canRedo: future.length > 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUndo: () => dispatch(UndoActionCreators.undo()),
    onRedo: () => dispatch(UndoActionCreators.redo())
  };
};

UndoRedo = connect(mapStateToProps, mapDispatchToProps)(UndoRedo);

export default UndoRedo;
